/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { EmailTypeSchema } from '../enums/EmailType.schema';
const baseSchema = z.object({
    type: EmailTypeSchema,
    email: z.string().min(1, { message: "Email must be between 1 and 100 characters." }).max(100, { message: "Email must be between 1 and 100 characters." }).email(),
    verifiedAt: z.coerce.date().nullish(),
    verifiedBy: z.string().nullish(),
}
).strict();
export const EmailSchema = baseSchema;
